import React from "react";

const ReRegisterFormNurse = ({ registerForm }) => {
  return (
    <React.Fragment>
      <React.Fragment>
        <h1 className="select-category-txt">Nurse Re-Registration Form</h1>

        <hr className="gray-hr" />

        <div className="group-back">
          <div>Nurse Re-Registration Form</div>
        </div>
        <div className="wrapper-brackground">
          <h2 className="title-details">Nurse Details</h2>

          <div className="bold mineShaft-color font-size-18 mb-5">
            Please confirm your details below. If any details are incorrect,
            please notify Pharmacare Group immeadiately of any changes to be
            made to your account.
          </div>
          <div className="container mt-5">
            <div className="row">
              <div className="col">
                <label>Nurse First Name:</label>
                <input
                  type="text"
                  name="first_name"
                  value={registerForm?.first_name}
                  disabled
                />
              </div>
              <div className="col">
                <label>Nurse Last Name:</label>
                <input
                  type="text"
                  name="last_name"
                  value={registerForm?.last_name}
                  disabled
                />
              </div>
            </div>

            <div className="row">
              <div className="col">
                <label>Registration Number:</label>
                <input
                  type="text"
                  name="registration_number"
                  value={registerForm?.registration_number}
                  disabled
                />
              </div>
              <div className="col">
                <label>Job Title:</label>
                <input
                  type="text"
                  name="job_title"
                  value={registerForm?.job_title}
                  disabled
                />
              </div>

              <div className="row">
                <div className="col">
                  <label>Hospital Name:</label>
                  <input
                    type="text"
                    name="hospital_name"
                    value={registerForm?.hospital?.value}
                    disabled
                  />
                </div>
                <div className="col"></div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <label>Hospital address:</label>
                <input
                  type="text"
                  name="hospital_address"
                  value={registerForm?.hospital?.address}
                  disabled
                />
              </div>
            </div>
          </div>

          <h2 className="title-details mt-2">Account Details</h2>

          <div className="container">
            <div className="row">
              <div className="col">
                <label>Email Address:</label>
                <input
                  type="text"
                  name="email"
                  value={registerForm?.email}
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </React.Fragment>
  );
};
export default ReRegisterFormNurse;
